import { Collapse, CollapseProps, List, ListItem, ListItemAvatar, ListItemButton, ListItemAvatarProps, ListItemIcon, ListItemIconProps, ListItemProps, ListItemSecondaryAction, ListItemSecondaryActionProps, ListItemText, ListItemTextProps, ListProps, ListSubheader, ListSubheaderProps } from '@mui/material';

// import {CcfListItem} from './../ccf-list-item';
import './ccf-list.module.scss';


/**
 * Component displays List like ul
 * @param props -ListProps
 * @example <CcfList/>
 */
export function CcfList({children, ...other}: ListProps) {
  return (
    <List {...other} >
      {children}
    </List>
  );
}

export interface CcfListItemProps extends ListItemProps {
  button?: boolean,
}

/**
 * Component displays ListItem like li
 * @param props -CcfListItemProps
 * @example <CcfListItem/>
 */
export function CcfListItem({children,button, ...other}: CcfListItemProps) {
  const componentName = button ? 'div' : 'li';
  return (
    <ListItem component={componentName} {...other}>
      {children}
    </ListItem>
  );
}

/**
 * Component displays ListItem like li
 * @param props -CcfListItemProps/
 * @example <CcfListItem/>
 */
export function CcfListItemButton({children,button,selected, ...other}: CcfListItemProps) {
  const componentName = button ? 'div' : 'li';
  return (
    <ListItemButton component={componentName} {...other}>
      {children}
    </ListItemButton>
  );
}

/**
 * Component displays List item icon
 * @param props -ListItemIconProps
 * @example <CcfListItemIcon/>
 */
export function CcfListItemIcon({children, ...other}: ListItemIconProps) {
  return (
    <ListItemIcon {...other} >
      {children}
    </ListItemIcon>
  );
}

/**
 * Component displays ListItemSecondaryAction
 * @param props -ListItemSecondaryActionProps
 * @example <CcfListItemSecondaryAction/>
 */
export function CcfListItemSecondaryAction(
  {children, ...other}: ListItemSecondaryActionProps
) {
  return (
    <ListItemSecondaryAction {...other} >
      {children}
    </ListItemSecondaryAction>
  );
}

/**
 * Component displays ListItemText
 * @example <CcfListItemText />
 */
export function CcfListItemText({children, ...other}: ListItemTextProps) {
  return (
    <ListItemText {...other} >
      {children}
    </ListItemText>
  );
}

/**
 * Component displays ListItemText
 * @param props -ListSubheaderProps
 * @example <CcfListItemText />
 */
export function CcfListSubheader({children, ...other}: ListSubheaderProps) {
  return (
    <ListSubheader {...other} >
      {children}
    </ListSubheader>
  );
}

/**
 * Component displays ListItemText
 * @param props -CollapseProps
 * @example <CcfListItemText />
 */
export function CcfCollapse({children, ...other}: CollapseProps) {
  return (
    <Collapse {...other} >
      {children}
    </Collapse>
  );
}

/**
 * Component displays ListItemText
 * @param props -CcfListItemTextProps
 * @example <CcfListItemText />
 */
export function CcfListItemAvatar({children, ...other}: ListItemAvatarProps) {
  return (
    <ListItemAvatar {...other} >
      {children}
    </ListItemAvatar>
  );
}

// export default {CcfList, CcfListItem, CcfListItemIcon, ListItemSecondaryAction, CcfListItemText, CcfListSubheader, CcfCollapse, CcfListItemAvatar};
